import withClassName from './withClassName'

export default withClassName
